module.exports = __webpack_public_path__ + "static/media/arrow-up.edabd1ae.svg";